import PropTypes from 'prop-types';
import { Button } from '@progress/kendo-react-buttons';
import React from 'react';

export default function CustomDialogActionsBar(props) {
  return props.buttons?.map((button) => {
    return button.visible === undefined ? (
      <Button icon={button.icon} key={Math.random()} onClick={button.onClick} className={button.text === "Non" ? "NonButton" : "blueButton"}>
        {button.text}
      </Button>
    ) : null;
  }
  );
}

CustomDialogActionsBar.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
    })
  ),
};
